import PropTypes from "prop-types";
import { CustomContainer } from "../../../DependencyHelper";
import {
  addOrdinalSuffix,
  getValueLabel,
} from "../../../../../utils/helperServices";
import formStyles from "../CreditCheckDetails.module.scss";

const EmploymentDetailsInfo = ({
  data,
  employmentTypes,
  employmentCategories,
  occupations,
}) => {
  return (
    <CustomContainer className={`${formStyles["form-details-container"]}`}>
      <CustomContainer className="row">
        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Employer name:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{data?.employerName}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Employment type:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{getValueLabel(data?.employmentType, employmentTypes)}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Employment category:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>
            {getValueLabel(data?.employmentCategory, employmentCategories)}
          </span>
        </CustomContainer>

        {data?.employerNumber && data?.employerNumber.length > 0 ? (
          <>
            <CustomContainer
              className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
            >
              <label>Employee telephone number:</label>
            </CustomContainer>
            <CustomContainer
              className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}
            >
              <span>{data?.employerNumber}</span>
            </CustomContainer>
          </>
        ) : null}

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Occupation:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{getValueLabel(data?.occupation, occupations)}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-md-6 col-sm-12`}
        >
          <label>Salary date:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-md-6 col-sm-12`}>
          <span>{addOrdinalSuffix(data?.salaryDate)}</span>
        </CustomContainer>

        <CustomContainer className={`${formStyles["pb-6"]} col-md-6 col-sm-12`}>
          <label>Gross monthly salary:</label>
        </CustomContainer>
        <CustomContainer className={`col-md-6 col-sm-12`}>
          <span>{data?.grossMonthlySalary}</span>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  );
};

EmploymentDetailsInfo.propTypes = {
  data: PropTypes.object,
  employmentTypes: PropTypes.array,
  employmentCategories: PropTypes.array,
  occupations: PropTypes.array,
};

EmploymentDetailsInfo.defaultProps = {
  data: {},
};

export default EmploymentDetailsInfo;
